export declare type ActionMap<
  M extends {
    [index: string]: unknown;
  }
> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

// 1. コンテキストの型を定義
export type SearchContextsTypes = {
  minBust: string;
  maxBust: string;
  minHeight: string;
  maxHeight: string;
  minBirthday: string;
  maxBirthday: string;
  keyword: string;
  busts: Array<string>;
  heights: Array<string>;
  actress: Array<Actress>;
};

export type Actress = {
  id: string;
  name: string;
  ruby: string;
  bust: string;
  cup: string;
  waist: string;
  hip: string;
  height: string;
  birthday: string;
  old: string;
  hobby: string;
  imageURL: string;
  listURL: string;
};

// 2. Actionタイプの種類を定義
export const ActionTypes = {
  SET_ITEM: 'SET_ITEM',
  SET_MAX_BUST: 'SET_MAX_BUST',
  SET_ACTRESS: 'SET_ACTRESS',
} as const;

// 3.1. ペイロードタイプの種類を定義
export type SearchPayloadTypes = {
  [ActionTypes.SET_ITEM]: SetItemPayloadType;
  [ActionTypes.SET_MAX_BUST]: SetMaxBustPayloadType;
  [ActionTypes.SET_ACTRESS]: SetActressPayloadType;
};

// 3.2. 個々のペイロードの型を定義
export type SetItemPayloadType = {
  item: string;
  value: string;
};

export type SetActressPayloadType = {
  actress: Array<Actress>;
};

export type SetMaxBustPayloadType = {
  maxBust: string;
};

// 4. コンテキストの更新の型を定義
export type SearchContextActions = ActionMap<SearchPayloadTypes>[keyof ActionMap<SearchPayloadTypes>];

// 個別の関数の型を定義
export type UpdateInputDataType = (item: string, value: string) => void;
